import i18n from '@/plugins/i18n/config.ts'

const { t } = i18n.global

export default {
  /* Add input validators here */
  emailRules: [
    (value: string) => !!value || t('validators.email.required'),
    (value: string) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value) || t('validators.email.invalid')
  ],
  passwordRules: [
    (value: string) => !!value || t('validators.password.required'),
    (value: string) => value.length >= 10 || t('validators.password.minLength'),
    (value: string) => /[A-Z]/.test(value) || t('validators.password.uppercase'),
    (value: string) => /\d/.test(value) || t('validators.password.number'),
    (value: string) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(value) || t('validators.password.special')
  ],
  confirmPasswordRules: [
    (value: string) => !!value || t('validators.confirmPassword.required'),
  ],
  chatRules: [
    (value: string) => !!value || t('validators.email.required')
  ],
  firstNameRules: [
    (value: string) => !!value || t('validators.firstName.required')
  ],
  lastNameRules: [
    (value: string) => !!value || t('validators.lastName.required')
  ],
  reasonRules: [
    (value: string) => !!value || t('validators.reason.required')
  ],

  // Mandate creation validators
  mandateNameRules: [
    (value: string) => !!value || t('validators.mandate.name.required')
  ],
  mandateAssetPercentageRules: [
    (value: string) => (value >= "1" && value <= "100") || t('validators.mandate.assetPercentage.range')
  ],
  mandatePercentageRules: [
    (value: string) => {
      const num = parseFloat((value ?? '').toString().replace(/,/g, '.'));
      return (!isNaN(num) && isFinite(num) && num >= 0 && num <= 100) || t('validators.mandate.percentage.range');
    }
  ],
  mandateMinimumInvestmentRules: (min: number) => [
    (value: string | number): string | true => {
      const num: number = Number(value)
      return (
        !isNaN(num) && num >= min
      ) || t('validators.mandate.minimumInvestment.range', { min })
    }
  ],

  mandateMaximumInvestmentRules: (min: number, max: number) => [
    (value: string | number): string | true => {
      const num: number = Number(value)
      return (
        !isNaN(num) && num >= min && num <= max
      ) || t('validators.mandate.maximumInvestment.range', { min, max })
    }
  ],
  mandateRecommendedDurationRules: [
    (value: string) => (value >= "1" && value <= "50") || t('validators.mandate.recommendedDuration.range')
  ],
  mandateAvailableAtRules: [
    (value: string) => !!value || t('validators.mandate.availableAt.required')
  ],
  mandateYoutubeRules: [
    (value: string) =>
      !value ||
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/).+$/i.test(value) ||
      t('validators.mandate.youtube.invalid')
  ],
  documentFileNameRules: [
    (value: string) => !!value || t('validators.mandate.documentFileName.required')
  ],
  documentFileRules: [
    (value: File) => !!value || t('validators.mandate.documentFile.required')
  ],
  documentCategoryRules: [
    (value: string) => !!value || t('validators.mandate.documentCategory.required')
  ],

  // Trade validators
  orderAmountRules: [
    (value: string) => !!value || t('validators.trade.orderAmount.required'),
    (value: string) => parseFloat(value) > 0 || t('validators.trade.orderAmount.positive')
  ],
  orderLimitPriceRules: [
    (value: string) => !!value || t('validators.trade.limitPrice.required'),
    (value: string) => parseFloat(value) > 0 || t('validators.trade.limitPrice.positive')
  ],
}
